import { Payout } from "@wingspanhq/wingspan-api-sdk";
import { SortKey } from "../routes/RouteDashboard/RouteDashboard";
import { getPayoutTotalAmount } from "./getPayoutTotalAmount";

export const sortData =
  (config: Record<SortKey, "asc" | "desc">) => (a: Payout, b: Payout) => {
    const sortByParam = Object.getOwnPropertyNames(config)[0] as SortKey;

    if (!sortByParam) return 0;

    const direction = config[sortByParam] === "asc" ? 1 : -1;

    if (sortByParam === "currentPeriodBalance") {
      return (getPayoutTotalAmount(a) - getPayoutTotalAmount(b)) * direction;
    }

    const dateA = a.events.createdAt
      ? new Date(a.events.createdAt).getTime()
      : 0;
    const dateB = b.events.createdAt
      ? new Date(b.events.createdAt).getTime()
      : 0;
    return (dateA - dateB) * direction;
  };
